module.exports = __webpack_public_path__ + "static/portrait-thumbs.f39b9114.png";